import React from 'react'
import styled, { css } from 'styled-components'

/* submitStatus === '2' || submitStatus === '4' ?  'background-color: rgba(0,180,0,.35);' : */
// eslint-disable-next-line no-unused-vars
const backgrounds = ({ submitStatus, selected }) => css`
  ${({ submitStatus }) =>
    submitStatus === '0'
      ? 'background-color: rgba(220,220,0,.35);'
      : submitStatus === '1' || submitStatus === '3'
      ? 'background-color: rgba(255,0,0,.13);'
      : ''} ${({ selected }) =>
    selected &&
    `
    color: #e7e7e7;
    background-color: #666;
   `};
`

// prettier ignore
export const Cell = styled(({ // isLabel,
  // isOverriden,
  // isHeader,
  // isDefaultRow,
  // width,
  // height,
  // submitStatus,
  // selected,
  // rowIndex,
  // columnIndex,
  // onEdit,
  // commitEdit,
  // editing,
  // editContent,
  // editInitKey,
  // colType,
  children, ...rest }) => <div {...rest}>{children}</div>)`
  padding: 0.4em;
  ${({ width }) => width && `flex: 0 0 ${width};`} ${({ width }) =>
  width && `max-width: ${width};`} ${({ height }) =>
  height && `height: ${height};`} text-align: center;
  border-right: solid #b7b7b7 1px;
  border-bottom: solid #b7b7b7 1px;

  user-select: none;
  cursor: default;
  ${props => backgrounds(props)} &:hover {
    ${({ isHeader }) =>
      !isHeader &&
      `
      background-color: #3cf;
      color: black;
    `};
  }
  ${({ isDefaultRow }) =>
    isDefaultRow &&
    `
    background-color: #004400;
    color: white;
  `} ${({ isHeader }) =>
  !isHeader &&
  `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `} ${({ isHeader }) =>
  isHeader &&
  `
    display: flex;
    background-color: steelblue;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: white;
    border-right: solid #e7e7e7 1px;
    border-bottom: solid #e7e7e7 1px;
  `} ${({ isOverriden }) =>
  isOverriden &&
  `
    position: relative;
    &:after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 10px 10px 0;
      border-color: transparent rgba(0,0,0,.5) transparent transparent;
    }
  `};
  ${({ isLabel }) =>
    isLabel &&
    `
    display: flex;
    background-color: steelblue;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: white;
    border-right: solid #e7e7e7 1px;
    border-bottom: solid #e7e7e7 1px;
      `};
`
// ${({ isOverriden }) => isOverriden && 'background-color: brown;'}
export default Cell
